<span>
  {{numericValue}}
</span>
